import withAPIAction from 'helpers/withAPIAction'
import { SupplierOrderListReq, SupplierOrderDetailReq, UpdateSupplierOrderStatusReq } from './types'
import {
  getSupplierOrderListAction,
  getSupplierOrderDetailAction,
  updateSupplierOrderStatusAction,
  getCountAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const quotationOrderListAPI = (data: SupplierOrderListReq, token: string, xmid: string) => {
  return withAPIAction<SupplierOrderListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierOrderList}`,
    data,
    token,
    xmid,
  })(getSupplierOrderListAction)
}

export const getSupplierOrderDetailAPI = (data: SupplierOrderDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getSupplierOrderByID.replace(':id', data.id.toString())
  return withAPIAction<SupplierOrderDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getSupplierOrderDetailAction)
}

export const updateSupplierOrderStatusAPI = (
  data: UpdateSupplierOrderStatusReq,
  token: string,
  xmid: string,
) => {
  const endPoint = APIPath.updateSupplierOrderStatus.replace(':id', data.id.toString())
  return withAPIAction<UpdateSupplierOrderStatusReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateSupplierOrderStatusAction)
}

export const getCountSupplierOrderAPI = (data: {}, token: string, xmid: any) => {
  return withAPIAction<{}>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countSupplierOrder}`,
    data,
    token,
    xmid,
  })(getCountAction)
}
